export default "__VITE_ASSET__d033b601__"